<template>
  <v-app>
    <template v-if="$route.path !== '/'">
      <v-app-bar color="indigo lighten-2" dark dense flat max-height="50px">
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

        <!-- <v-img
          class="mx-2 logo-image"
          src="@/assets/logo.png"
          max-width="120"
          contain
        ></v-img> -->
        <div class="name-div">
          <!-- Energy Performance and Smart Readiness Certification Tool -->
          BELIT Smart Ready
        </div>
        <v-spacer></v-spacer>

        <v-menu left bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-account</v-icon>
                </template>
                <span>{{ email }}</span>
              </v-tooltip>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in accountItems"
              :key="index"
              @click="handleClick(item)"
            >
              <v-list-item-content>
                {{ item }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-dialog v-model="accountDialog" style="z-index: 1000" max-width="500">
        <v-card>
          <v-card-title>
            <span class="font-weight-light text-h5">Account information</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="accountDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mb-10"> <b>Email:</b> {{ email }} </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn @click="storeTokenDialog = true">Belit platform token</v-btn>
            <v-btn @click="handleOpenPasswordAssistanceDialog"
              >Password reset</v-btn
            >
            <v-btn color="primary" @click="accountDialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="storeTokenDialog"
        style="z-index: 1000"
        max-width="500"
      >
        <v-card>
          <v-card-title>
            <span class="font-weight-light text-h5">Access token</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="storeTokenDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mb-10">
            <PersonalTokenForm
              @submitPersonalToken="handleSubmitPersonalToken"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="passwordResetDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="font-weight-light text-h5">
            Reset password
          </v-card-title>
          <v-card-text
            >Please enter the password reset token you received in your email
            and write the new password.

            <PasswordResetForm
          /></v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="passwordResetDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="passwordAssistanceDialog" max-width="500px">
        <v-card class="px-5">
          <v-card-title class="font-weight-light text-h5">
            Password assistance
          </v-card-title>
          <v-card-text>
            To recieve password reset token, please enter the email address
            associated with your account. If you already recieved a token, click
            on "I HAVE A TOKEN" button.
            <PasswordAssistance class="mt-5" />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="passwordResetDialog = true">I have a token</v-btn>
            <v-btn color="primary" @click="passwordAssistanceDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-list nav dense>
          <v-list-item-group v-model="group">
            <router-link to="/" class="router-link">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Login</v-list-item-title>
              </v-list-item>
            </router-link>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </template>
    <v-main style="min-height: 860px">
      <keep-alive>
        <router-view />
      </keep-alive>
    </v-main>

    <v-snackbar
      timeout="2000"
      :value="snackbarVisible"
      absolute
      color="success"
      top
    >
      <div class="text-center">
        <span>Personal access token saved successfully.</span>
      </div>
    </v-snackbar>

    <v-footer
      v-if="$route.path !== '/'"
      color="indigo lighten-2"
      max-height="55px"
    >
      <v-col class="text-center" cols="12" style="color: white">
        {{ new Date().getFullYear() }} — <strong>BELIT Smart Ready</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import services from "./rest/Services";
import router from "./router";
import PasswordAssistance from "./components/PasswordAssistance.vue";
import PasswordResetForm from "./components/PasswordResetForm.vue";
import PersonalTokenForm from "./components/PersonalTokenForm.vue";
import EventBus from "./components/EventBus";

export default {
  name: "App",
  components: {
    PasswordAssistance,
    PasswordResetForm,
    PersonalTokenForm,
  },
  data: () => ({
    drawer: false,
    group: null,
    accountItems: ["Account", "Logout"],
    accountDialog: false,
    passwordResetDialog: false,
    passwordAssistanceDialog: false,
    storeTokenDialog: false,
    snackbarVisible: false,
  }),
  methods: {
    logout: function () {
      services
        .logout()
        .then((response) => {
          console.log("response :>> ", response);
          localStorage.removeItem("jwt");
          router.push("/");
        })
        .catch((error) => {
          console.log("Error while trying to logout ", error);
        });
    },
    handleClick(item) {
      switch (item) {
        case "Account":
          this.accountDialog = true;
          break;
        case "Logout":
          EventBus.$emit("logout");
          this.logout();
          break;

        default:
          break;
      }
    },
    handleOpenPasswordAssistanceDialog: function () {
      this.accountDialog = false;
      this.passwordAssistanceDialog = true;
    },

    handleSubmitPersonalToken: function (token) {
      services
        .savePersonalAccessToken({ personal_access_token: token })
        .then((response) => {
          console.log("response :>> ", response);
          this.storeTokenDialog = false;
          this.accountDialog = false;
          this.snackbarVisible = true;
        })
        .catch((error) => {
          console.log("error while saving personal access token", error);
        });
    },
  },
  mounted() {
    document.title = "BELIT Smart Ready";
  },
  computed: {
    email: function () {
      const account = JSON.parse(sessionStorage.getItem("account"));
      return account.email;
    },
  },
};
</script>

<style>
.router-link {
  text-decoration: none;
}
.name-div {
  margin-left: 10px;
}
@media only screen and (max-width: 320px) {
  .name-div {
    display: none;
  }
}
@media only screen and (min-width: 320px) {
  .name-div {
    max-width: 150px;
    font-size: 10px;
    margin-left: 5px;
  }
}
@media only screen and (min-width: 400px) {
  .name-div {
    max-width: 200px;
    font-size: 12px;
    margin-left: 10px;
  }
}
@media only screen and (min-width: 600px) {
  .name-div {
    max-width: 400px;
    font-size: 14px;
    margin-left: 15px;
  }
}
</style>
